import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import { useScreenClass, GridContainer, Row, Column } from '@vp/swan';
import { IssueForm } from './IssueForm.js';
import { ReplacementSummary } from '../replacement-summary/ReplacementSummary.js';
import './styles.scss.js';

const IssuesLayout=()=>{const screenClass=useScreenClass();return jsx(GridContainer,{"data-cy":"issues-step-container",children:jsxs(Row,{children:[jsx(Column,{"data-cy":"issues-step-form-container",className:"issues-step-form-container",pl:0,pr:{xs:0,sm:"5"},span:8,spanLg:8,spanMd:7,spanSm:7,spanXl:8,spanXs:12,children:jsx(IssueForm,{})}),jsx(Column,{"data-cy":"issues-step-summary",px:screenClass==="xs"?0:undefined,spanXs:12,spanMd:5,spanSm:5,span:4,children:jsx(ReplacementSummary,{})})]})})};

export { IssuesLayout };
//# sourceMappingURL=IssuesLayout.js.map
